export const KentuckyHistoryEvents = [
    {
        "title": "Dec 20, 1796",
        "eventType": "Extreme Cold",
        "cardTitle": "Ohio River Freezes Over",
        "cardSubtitle": "Severe winter freeze",
        "decade": "1790",
        "cardDetailedText": "The Ohio River froze over, with up to 9” of ice. Boats were encased in ice and unable to continue floating down river. (Source: Kentucky Weather by Jerry Hill pg. 123).",
        "url": []
    },
    {
        "title": "Dec 1811 – Feb 1812",
        "eventType": "Earthquake",
        "cardTitle": "New Madrid Earthquakes",
        "cardSubtitle": "Three major earthquakes > 7.0 magnitude",
        "decade": "1810",
        "cardDetailedText": "Three earthquakes with a magnitude > 7.0 struck along the New Madrid fault in Western Kentucky between December 1811 and February 1812.",
        "url": [
            "https://kgs.uky.edu/kgsweb/olops/pub/kgs/SP17_12.pdf"]
    },
    {
        "title": "1816",
        "eventType": "Extreme Cold",
        "cardTitle": "Year Without a Summer",
        "cardSubtitle": "Global cooling after Tambora eruption",
        "decade": "1810",
        "cardDetailedText": "The Tambora volcano in Indonesia erupted, decreasing temperatures worldwide. Kentuckians report an unusually cold summer with a prolonged haze in the sky. People reported snow and ice across the state during the summer months. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Feb 7, 1835",
        "eventType": "Extreme Cold",
        "cardTitle": "Bowling Green Cold Snap",
        "cardSubtitle": "Temperature drops to -18°F",
        "decade": "1830",
        "cardDetailedText": "Thermometers read as low as -18° F, as reported by John Younglove in Bowling Green. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Feb 8, 1835",
        "eventType": "Extreme Cold",
        "cardTitle": "Lexington Record Low",
        "cardSubtitle": "Extreme cold of -21°F",
        "decade": "1830",
        "cardDetailedText": "Extreme cold of -21° F measured at Transylvania University in Lexington. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Jan 1855",
        "eventType": "Extreme Cold",
        "cardTitle": "Ohio River Freezes Again",
        "cardSubtitle": "Bitter cold freezes river",
        "decade": "1850",
        "cardDetailedText": "An average monthly temperature of 18.33°F causes the Ohio River to freeze in Northern Kentucky. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Jan 1, 1864",
        "eventType": "Extreme Cold",
        "cardTitle": "Louisville Record Low",
        "cardSubtitle": "Extreme cold of -19.5°F",
        "decade": "1860",
        "cardDetailedText": "Extreme cold of -19.5° F measured in Louisville. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Feb 4, 1884",
        "eventType": "Flood",
        "cardTitle": "Ohio River Valley Flooding",
        "cardSubtitle": "Major flooding impacts multiple cities",
        "decade": "1880",
        "cardDetailedText": "A storm that began on February 4, 1884, causes major flooding along the Ohio River Valley with impacts to Louisville, Paducah, Ashland, and Catlettsburg. Parts of Louisville remained underwater for most of February. (Source: Kentucky Weather by Jerry Hill pg. 73).",
        "url": []
    },
    {
        "title": "Mar 27, 1890",
        "eventType": "Tornado",
        "cardTitle": "1890 Louisville Tornado",
        "cardSubtitle": "Deadliest tornado in Kentucky history",
        "decade": "1890",
        "cardDetailedText": "An F4 tornado touched down in Jefferson County and tracked through much of Louisville. Significant building damage across downtown Louisville. There were 76 fatalities, making this tornado the deadliest in Kentucky’s history. Four other tornadoes were recorded across Kentucky on this day.",
        "url": [
            "https://www.weather.gov/lmk/tornado_climatology_march271890",
            "https://www.weather.gov/lmk/violent_tornadoes_kentucky"]
    },
    {
        "title": "Dec 25, 1890",
        "eventType": "Winter Weather",
        "cardTitle": "Lexington Ice Storm",
        "cardSubtitle": "Winter storm damages communication lines",
        "decade": "1890",
        "cardDetailedText": "An ice storm hit Lexington, Kentucky, bringing down telephone, telegraph, and electric lines. (Source: Kentucky Weather by Jerry Hill pg. 65).",
        "url": []
    },
    {
        "title": "Apr 1896",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest April on Record",
        "cardSubtitle": "Statewide temperature 5.6°F above normal",
        "decade": "1890",
        "cardDetailedText": "Warmest April in Kentucky’s history with a statewide average temperature of 62.0°F, 5.6°F above normal.",
        "url": []
    },
    {
        "title": "Sep 1897",
        "eventType": "Drought",
        "cardTitle": "Driest September on Record",
        "cardSubtitle": "Only 0.30” of rain statewide",
        "decade": "1890",
        "cardDetailedText": "Second driest September on record with a state average 0.30” of rainfall, 3.29” below-normal (only 8% of normal).",
        "url": []
    },
    {
        "title": "Feb 11, 1899",
        "eventType": "Extreme Cold",
        "cardTitle": "Brutal 1899 Cold Wave",
        "cardSubtitle": "Record lows and statewide disruption",
        "decade": "1890",
        "cardDetailedText": "Extreme cold temperatures across the Commonwealth with -30° F in Loretto and -33° F in Sandy Hook. All of February 1899 was extremely cold. Schools and businesses were closed for multiple days, and trains were unable to run for parts of the month. People kept fires burning at home to stay warm, but which resulted in a number of house fires, including the governor's mansion in Frankfort. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Nov-00",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest November on Record",
        "cardSubtitle": "Statewide rainfall 233% of normal",
        "decade": "1900",
        "cardDetailedText": "Wettest November on record with a state average 8.25”, 4.71” above normal (233% of normal).",
        "url": []
    },
    {
        "title": "1-Jul",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest July on Record",
        "cardSubtitle": "Statewide average 81.2°F",
        "decade": "1900",
        "cardDetailedText": "Warmest July on record with a state average 81.2°F, 4.8°F above average.",
        "url": []
    },
    {
        "title": "28-Feb-02",
        "eventType": "Pressure Record",
        "cardTitle": "Record Low Pressure in Lexington",
        "cardSubtitle": "28.94 inHg / 980.0 mb",
        "decade": "1900",
        "cardDetailedText": "A reading of 28.94 inches of mercury/980.0 millibars observed in Lexington, Kentucky, one of the lowest pressure systems recorded in the state. (Pressures corrected to sea level) (Source: Kentucky Weather by Jerry Hill; NWS).",
        "url": [
            "https://www.weather.gov/media/lmk/climate/clilex/wind_and_clouds.pdf"]
    },
    {
        "title": "7-Apr",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest April on Record",
        "cardSubtitle": "Statewide average 47.5°F",
        "decade": "1900",
        "cardDetailedText": "Coldest April in Kentucky history with a state average temperature of 47.5°F, a chilly 8.9°F below normal.",
        "url": []
    },
    {
        "title": "10-Mar",
        "eventType": "Drought",
        "cardTitle": "Driest March on Record",
        "cardSubtitle": "Only 0.89” of rainfall",
        "decade": "1910",
        "cardDetailedText": "The driest March on record at 0.89”, only 19% (-3.79”) of normal.",
        "url": []
    },
    {
        "title": "13-Jan",
        "eventType": "High Precipitation",
        "cardTitle": "Third Wettest January",
        "cardSubtitle": "302% of normal rainfall",
        "decade": "1910",
        "cardDetailedText": "The third wettest January on record at 11.29”, over 7.55” (302%) of normal.",
        "url": []
    },
    {
        "title": "15-Apr",
        "eventType": "Drought",
        "cardTitle": "Driest April on Record",
        "cardSubtitle": "Only 1.00” of rainfall",
        "decade": "1910",
        "cardDetailedText": "Driest April on record with 1.00” of rainfall, -3.73” below normal (21% of average).",
        "url": []
    },
    {
        "title": "1917",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest Year on Record",
        "cardSubtitle": "Statewide average 52.6°F",
        "decade": "1910",
        "cardDetailedText": "The coldest year on record (1895–present) with a state average 52.6°F, a cool 3.7°F below normal.",
        "url": []
    },
    {
        "title": "17-May",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest May on Record",
        "cardSubtitle": "Average temperature 58°F",
        "decade": "1910",
        "cardDetailedText": "Kentucky’s coldest May on record with a state average 58°F, a cool 7.2°F below average.",
        "url": []
    },
    {
        "title": "21-May-17",
        "eventType": "Severe Storm",
        "cardTitle": "Large Hail in Lexington",
        "cardSubtitle": "Hail up to 3.25 inches",
        "decade": "1910",
        "cardDetailedText": "An isolated thunderstorm went through Lexington and dropped hail 3.25 inches in diameter. (Source: Kentucky Weather by Jerry Hill pg. 84).",
        "url": []
    },
    {
        "title": "27-May-17",
        "eventType": "Tornado",
        "cardTitle": "Second Deadliest Tornado",
        "cardSubtitle": "F4 tornado kills 67",
        "decade": "1910",
        "cardDetailedText": "An F4 tornado caused 67 deaths and 345 injuries across Fulton, Hickman, and Graves Counties. The tornado originated in Tennessee but moved into southwest Kentucky, resulting in around $1,000,000 in damage. This tornado is the second-deadliest tornado in Kentucky’s history.",
        "url": [
            "https://www.weather.gov/lmk/violent_tornadoes_kentucky"]
    },
    {
        "title": "Dec 1917 – Feb 1918",
        "eventType": "Extreme Cold",
        "cardTitle": "Third Coldest Winter on Record",
        "cardSubtitle": "Ohio River freezes completely",
        "decade": "1910",
        "cardDetailedText": "Third coldest winter in state history (behind 1976–1977 and 1977–1978). The average snowfall across Kentucky in December 1917 was 17.3 inches. Temperatures were below 0°F in January 1918, and mixed with high winds for an enhanced wind chill. The extremely cold winter negatively affected Kentucky’s tobacco industry. The entire length of the Ohio River froze, halting water transportation and causing significant damage to many boats. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "18-Sep",
        "eventType": "Extreme Cold",
        "cardTitle": "Coolest September on Record",
        "cardSubtitle": "Statewide average 62.0°F",
        "decade": "1910",
        "cardDetailedText": "Kentucky’s coolest September on record with a state average 62.0°F, 6.8°F below average.",
        "url": []
    },
    {
        "title": "Sep – Nov 1919",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Fall on Record (Tied)",
        "cardSubtitle": "16.95” total rainfall",
        "decade": "1910",
        "cardDetailedText": "Tied with 2018 as the wettest fall on record with 16.95”, 159% of normal (6.32” above-normal).",
        "url": []
    },
    {
        "title": "19-Oct",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest October on Record",
        "cardSubtitle": "7.78” rainfall (222% of normal)",
        "decade": "1910",
        "cardDetailedText": "Wettest October on record with a state average 7.78”, 4.28” above average (222% of normal).",
        "url": []
    },
    {
        "title": "19-Oct",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest October on Record",
        "cardSubtitle": "Average temperature 64.5°F",
        "decade": "1910",
        "cardDetailedText": "Warmest October on record with a state average 64.5°F, 6.9°F above average.",
        "url": []
    },
    {
        "title": "1921",
        "eventType": "Extreme Heat",
        "cardTitle": "Second Warmest Year",
        "cardSubtitle": "Statewide average 58.7°F",
        "decade": "1920",
        "cardDetailedText": "Kentucky’s 2nd warmest year with a state average 58.7°F, 2.4°F above average.",
        "url": []
    },
    {
        "title": "18-Mar-25",
        "eventType": "Tornado",
        "cardTitle": "1925 F4 Tornado Outbreak",
        "cardSubtitle": "39 fatalities across 4 counties",
        "decade": "1920",
        "cardDetailedText": "An F4 tornado originating in Tennessee traveled north into Allen, Barren, Monroe, and Metcalfe Counties. With a path of 60 miles, the tornado damaged 150 homes and caused 39 fatalities.",
        "url": []
    },
    {
        "title": "25-Aug",
        "eventType": "Drought",
        "cardTitle": "Driest August on Record",
        "cardSubtitle": "Only 1.48” of rainfall",
        "decade": "1920",
        "cardDetailedText": "Driest August on record with 1.48”, 3.62” below normal (41% of normal).",
        "url": []
    },
    {
        "title": "25-Sep",
        "eventType": "Extreme Heat",
        "cardTitle": "Hottest September on Record",
        "cardSubtitle": "Average temperature 76.0°F",
        "decade": "1920",
        "cardDetailedText": "Kentucky’s hottest September on record with a state average 76.0°F, a warm 7.2°F above average.",
        "url": []
    },
    {
        "title": "26-Aug",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest August on Record",
        "cardSubtitle": "7.51” of rainfall",
        "decade": "1920",
        "cardDetailedText": "Wettest August on record with 7.51”, 3.89” above normal (207% of normal).",
        "url": []
    },
    {
        "title": "27-Aug",
        "eventType": "Extreme Cold",
        "cardTitle": "Coolest August on Record (Tied)",
        "cardSubtitle": "Average temperature 70.0°F",
        "decade": "1920",
        "cardDetailedText": "Tied with August 1967 as Kentucky’s coolest August with a state average 70.0°F, 5.3°F below average.",
        "url": []
    },
    {
        "title": "28-Jun",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest June on Record",
        "cardSubtitle": "11.67” of rainfall statewide",
        "decade": "1920",
        "cardDetailedText": "Wettest June on record with 11.67”, 6.95” above normal (247% of normal).",
        "url": []
    },
    {
        "title": "Jun – Aug 1928",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Summer on Record",
        "cardSubtitle": "20.12” total rainfall",
        "decade": "1920",
        "cardDetailedText": "Wettest summer on record with a state average 20.12”, 152% of normal (6.92” above normal).",
        "url": []
    },
    {
        "title": "1930",
        "eventType": "Drought",
        "cardTitle": "Driest Year on Record",
        "cardSubtitle": "29.0” of rain statewide",
        "decade": "1930",
        "cardDetailedText": "The driest year in state history with a state average 29.0”, 58% of normal and 21.36” below normal. The drought was accompanied by heat waves during the summer with significant agricultural losses. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Mar – May 1930",
        "eventType": "Drought",
        "cardTitle": "Second Driest Spring",
        "cardSubtitle": "Only 6.74” rainfall",
        "decade": "1930",
        "cardDetailedText": "Second driest spring on record with 6.74”, 7.76” below-normal (46% of average).",
        "url": []
    },
    {
        "title": "Jun – Aug 1930",
        "eventType": "Drought",
        "cardTitle": "Driest Summer on Record",
        "cardSubtitle": "5.54” total rainfall",
        "decade": "1930",
        "cardDetailedText": "Driest summer on record with a state average 5.54”, 7.66” below-normal (42% of normal).",
        "url": []
    },
    {
        "title": "30-Jul",
        "eventType": "Drought",
        "cardTitle": "Driest July on Record",
        "cardSubtitle": "Only 1.44” of rain",
        "decade": "1930",
        "cardDetailedText": "Driest July on record with 1.44”, 3.42” below normal (30% of normal).",
        "url": []
    },
    {
        "title": "28-Jul-30",
        "eventType": "Extreme Heat",
        "cardTitle": "Record Heat in Greensburg",
        "cardSubtitle": "114°F recorded",
        "decade": "1930",
        "cardDetailedText": "Record high temperatures were recorded across the state, the highest of which was 114° F in Greensburg. Prolonged heat waves characterized the entire summer. Lovelaceville recorded 30 days with highs over 100° F. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Sep – Nov 1931",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest Fall on Record",
        "cardSubtitle": "Average temperature 62.6°F",
        "decade": "1930",
        "cardDetailedText": "Warmest fall on record with a state average 62.6°F, 5.1°F above average.",
        "url": []
    },
    {
        "title": "Nov-31",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest November on Record",
        "cardSubtitle": "Average temperature 53.4°F",
        "decade": "1930",
        "cardDetailedText": "Kentucky’s warmest November on record with a state average 53.4°F, 7.2°F above average.",
        "url": []
    },
    {
        "title": "Dec 1931 – Feb 1932",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest Winter on Record",
        "cardSubtitle": "Statewide average 44.2°F",
        "decade": "1930",
        "cardDetailedText": "Warmest winter on record with a state average 44.2°F, 7.3°F above average.",
        "url": []
    },
    {
        "title": "2-Aug-32",
        "eventType": "Flood",
        "cardTitle": "Lexington Flash Flood",
        "cardSubtitle": "Up to 7.5 inches of rain",
        "decade": "1930",
        "cardDetailedText": "Flooding rains in Richmond (6 inches) and Lexington (7.5 inches). The heavy rain caused 4 to 5 feet of water to rush through downtown Lexington. Six people drowned in their houses along Hickman Creek when the flooding swept away their homes. (Source: Kentucky Weather by Jerry Hill pg. 71).",
        "url": []
    },
    {
        "title": "9-May-33",
        "eventType": "Tornado",
        "cardTitle": "1933 F4 Tornado Outbreak",
        "cardSubtitle": "36 deaths, 87 injuries",
        "decade": "1930",
        "cardDetailedText": "A short storm ended in an F4 tornado across Monroe, Cumberland, Adair, and Russell counties. Following the tornado, heavy rains continued through the night, flooding many roads. The storm caused over 100 casualties including 36 deaths and 87 injuries.",
        "url": []
    },
    {
        "title": "Jun-36",
        "eventType": "Drought",
        "cardTitle": "Driest June on Record",
        "cardSubtitle": "Only 0.81” of rain",
        "decade": "1930",
        "cardDetailedText": "Driest June in state history with an average rainfall of 0.81”, only 17% of normal (3.91” below normal).",
        "url": []
    },
    {
        "title": "Jun – Aug 1936",
        "eventType": "Extreme Heat",
        "cardTitle": "Hottest Summer on Record",
        "cardSubtitle": "Average 78.6°F statewide",
        "decade": "1930",
        "cardDetailedText": "Kentucky’s hottest summer on record with an average temperature of 78.6°F, a very hot 3.7°F above normal.",
        "url": []
    },
    {
        "title": "Jun – Aug 1936",
        "eventType": "Drought",
        "cardTitle": "Second Driest Summer",
        "cardSubtitle": "Only 7.10” rainfall",
        "decade": "1930",
        "cardDetailedText": "Second driest summer on record with an average rainfall of 7.10”, only 54% of normal (6.10” below normal).",
        "url": []
    },
    {
        "title": "1936",
        "eventType": "Extreme Heat",
        "cardTitle": "Extreme Heat and Drought",
        "cardSubtitle": "Hot and dry conditions, no A/C",
        "decade": "1930",
        "cardDetailedText": "The summer of 1936 was very hot (hottest on record) and very dry (2nd driest on record). The average temperature in Louisville from June to August was 81.0°F, 4.5°F above normal. The year started dry, and heat waves expanded over the summer. Drought accompanied the heat. Air conditioning units were not widely available yet, compounding the effects of the heat. (Sources: Kentucky Weather by Jerry Hill, NWS).",
        "url": [
            "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"]
    },
    {
        "title": "Dec 1936 – Feb 1937",
        "eventType": "High Precipitation",
        "cardTitle": "Second Wettest Winter",
        "cardSubtitle": "22.42” of precipitation",
        "decade": "1930",
        "cardDetailedText": "Second wettest winter on record with 22.42”, 186% of normal (10.39” above normal).",
        "url": []
    },
    {
        "title": "Jan-37",
        "eventType": "Flood",
        "cardTitle": "The Great Flood of 1937",
        "cardSubtitle": "Most destructive flood in state history",
        "decade": "1930",
        "cardDetailedText": "Kentucky’s wettest month on record, and among the top natural disasters to befall the Commonwealth. Known as the “The Great Flood of 1937”, the average state rainfall total for the moth was 15.16”, a record 11.42” above average. Some areas recorded over 22” for the month. The Ohio, Kentucky, Green, and Barren rivers all flooded. Large areas of Louisville, Frankfort, and Paducah were underwater. Over 90% of Paducah and 50% of Louisville was flooded, causing the evacuation of ~175,000 people. The Ohio River reached a crest of 85.4 feet on January 27, 1937, over 30 feet above flood stage. The flood caused an estimated 190 fatalities in Louisville, 435 fatalities region wide, and $5 billion in damage (2024 dollars). ",
        "url": [
            "https://www.weather.gov/safety/flood-states-ky"]
    },
    {
        "title": "Jul 4 – Jul 5, 1939",
        "eventType": "Flood",
        "cardTitle": "Breathitt County Flash Flood",
        "cardSubtitle": "Wall of water up to 22 feet",
        "decade": "1930",
        "cardDetailedText": "About 12+ inches of precipitation fell in Breathitt County in southeastern Kentucky, causing severe flash flooding overnight. A wall of water estimated of up to 22 feet flowed through the valleys killing 79. (Source: NWS).",
        "url": [
            "https://www.weather.gov/jkl/frozenflood1939"]
    },
    {
        "title": "1941",
        "eventType": "Drought",
        "cardTitle": "Third Driest Year on Record",
        "cardSubtitle": "Only 34.49” of rainfall",
        "decade": "1940",
        "cardDetailedText": "Third driest year on record with a state average 34.49”, 68% of normal and 15.87” below normal.",
        "url": []
    },
    {
        "title": "Mar – May 1941",
        "eventType": "Drought",
        "cardTitle": "Driest Spring on Record",
        "cardSubtitle": "Only 5.92” of rainfall",
        "decade": "1940",
        "cardDetailedText": "Driest spring on record with a state average of only 5.92” of rain, 8.58” below normal (41% of normal).",
        "url": []
    },
    {
        "title": "May-41",
        "eventType": "Drought",
        "cardTitle": "Driest May on Record",
        "cardSubtitle": "1.15” statewide average",
        "decade": "1940",
        "cardDetailedText": "Driest May on record with a state average of only 1.15”, 3.94” below normal (23% of normal).",
        "url": []
    },
    {
        "title": "Mar-45",
        "eventType": "Flood",
        "cardTitle": "Ohio River Floods Louisville",
        "cardSubtitle": "50,000 evacuated",
        "decade": "1940",
        "cardDetailedText": "The Ohio River flooded at Louisville after four waves of heavy precipitation fell over a three week period. Although the Ohio River did not flood as high as during the Great Flood of 1937, the flood still caused around $2,600,000 in damage and the evacuation of 50,000 people.",
        "url": []
    },
    {
        "title": "Feb-47",
        "eventType": "Drought",
        "cardTitle": "Driest February on Record",
        "cardSubtitle": "Average of 0.65” statewide",
        "decade": "1940",
        "cardDetailedText": "Kentucky’s driest February on record. The state recorded an average 0.65”, only 17% (-3.21”) of normal.",
        "url": []
    },
    {
        "title": "Jul-47",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest July on Record",
        "cardSubtitle": "Average temperature 71.4°F",
        "decade": "1940",
        "cardDetailedText": "Kentucky’s coldest July on record with a state average 71.4°F, 5.0°F below average.",
        "url": []
    },
    {
        "title": "Dec 1949 – Feb 1950",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Winter on Record",
        "cardSubtitle": "23.47” total precipitation",
        "decade": "1950",
        "cardDetailedText": "Wettest winter on record in Kentucky with a state average 23.47”, 195% of normal (11.44” above normal).",
        "url": []
    },
    {
        "title": "Jan-50",
        "eventType": "High Precipitation",
        "cardTitle": "Second Wettest January",
        "cardSubtitle": "12.61” statewide average",
        "decade": "1950",
        "cardDetailedText": "The second wettest January on record with a state average rainfall of 12.61”, a full 8.87” above average.",
        "url": []
    },
    {
        "title": "Jan-50",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest January on Record",
        "cardSubtitle": "Average temperature 43.9°F",
        "decade": "1950",
        "cardDetailedText": "The state’s warmest January with a state average 43.9°F, a whopping 9.5°F above normal.",
        "url": []
    },
    {
        "title": "Winter 1951",
        "eventType": "Winter Weather",
        "cardTitle": "Severe 1951 Ice Storm",
        "cardSubtitle": "Ice followed by subzero temperatures",
        "decade": "1950",
        "cardDetailedText": "A high-pressure system pulled polar air south, while a low-pressure system from the Gulf of Mexico moved north. These systems combined for an impactful ice storm that covered the region. Temperatures dropped below 0°F after all the snow and ice fell, causing additional problems across the state.(Source: Kentucky Weather by Jerry Hill pg. 66).",
        "url": []
    },
    {
        "title": "2-Feb-51",
        "eventType": "Extreme Cold",
        "cardTitle": "Bowling Green Cold Snap",
        "cardSubtitle": "-20°F with heavy snow",
        "decade": "1950",
        "cardDetailedText": "Temperature dropped to -20°F in Bowling Green, with 9 inches of snow on the ground. At least two storm-related deaths in Kentucky due to the snowstorm and cold. (Source: Kentucky Weather by Jerry Hill pg. 68).",
        "url": []
    },
    {
        "title": "1952",
        "eventType": "Drought",
        "cardTitle": "Statewide Drought",
        "cardSubtitle": "36-day dry spell in Louisville",
        "decade": "1950",
        "cardDetailedText": "Severe, statewide drought across central and western Kentucky. Louisville had 36 consecutive days with no measurable rainfall during the fall of 1952. (Source: Kentucky Weather by Jerry Hill pg. 106).",
        "url": []
    },
    {
        "title": "Jun-52",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest June on Record",
        "cardSubtitle": "Statewide average 78.4°F",
        "decade": "1950",
        "cardDetailedText": "Kentucky’s warmest June on record with a state average 78.4°F, 5.4°F above average.",
        "url": []
    },
    {
        "title": "1-Aug-52",
        "eventType": "Hail",
        "cardTitle": "Boyle County Hailstorm",
        "cardSubtitle": "$810,000 in damage",
        "decade": "1950",
        "cardDetailedText": "A hailstorm caused $810,000 in damage in Boyle County. (Source: Kentucky Weather by Jerry Hill pg. 87).",
        "url": []
    },
    {
        "title": "Sep – Nov 1953",
        "eventType": "Drought",
        "cardTitle": "Driest Fall on Record",
        "cardSubtitle": "Only 3.48” of rainfall",
        "decade": "1950",
        "cardDetailedText": "Driest fall on record with a state average 3.48”, only 33% of normal (7.15” below normal).",
        "url": []
    },
    {
        "title": "1954",
        "eventType": "Drought",
        "cardTitle": "Extreme 1954 Drought",
        "cardSubtitle": "Severe and extreme drought all year",
        "decade": "1950",
        "cardDetailedText": "Kentucky experienced extreme drought conditions from January to September and severe conditions from October to December of 1954.",
        "url": [
            "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"]
    },
    {
        "title": "Jun-55",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest June on Record",
        "cardSubtitle": "Statewide average 67.5°F",
        "decade": "1950",
        "cardDetailedText": "Kentucky’s coldest June on record with a state average 67.5°F, 5.5°F below average.",
        "url": []
    },
    {
        "title": "Jan – Feb 1957",
        "eventType": "Flood",
        "cardTitle": "Eastern Kentucky Flooding",
        "cardSubtitle": "Major flooding and mudslides",
        "decade": "1950",
        "cardDetailedText": "Over 6” of rain fell in just a few days across eastern Kentucky. The Big Sandy, Cumberland, and Kentucky Rivers all flooded. Major roads were blocked due to mudslides and water, causing many people to be stranded. There were nine fatalities. (Source: NWS).",
        "url": [
            "https://www.weather.gov/jkl/1957flood"]
    },
    {
        "title": "1958",
        "eventType": "Extreme Cold",
        "cardTitle": "Second Coldest Year",
        "cardSubtitle": "Average temperature 53.0°F",
        "decade": "1950",
        "cardDetailedText": "Kentucky’s second coldest year with a state average 53.0°F, 3.7°F below average.",
        "url": []
    },
    {
        "title": "Mar-60",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest March on Record",
        "cardSubtitle": "Average temperature 30.7°F",
        "decade": "1960",
        "cardDetailedText": "Coldest March in state history with an average temperature of 30.7°F, a cold 15.7°F below normal.",
        "url": []
    },
    {
        "title": "Mar – May 1960",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest Spring on Record",
        "cardSubtitle": "Average temperature 50.1°F",
        "decade": "1960",
        "cardDetailedText": "The coldest spring in state history with an average temperature of 50.1°F, a very cold 5.9°F below average.",
        "url": []
    },
    {
        "title": "Mar 7–10, 1960",
        "eventType": "Winter Weather",
        "cardTitle": "Bowling Green Snowstorm",
        "cardSubtitle": "27 inches of snow",
        "decade": "1960",
        "cardDetailedText": "In Bowling Green, 27 inches of snow fell. During March, Bowling Green also saw average temperatures 15.8°F less than normal. (Source: Kentucky Weather by Jerry Hill; WKU).",
        "url": [
            "https://www.wku.edu/news/articles/index.php?view=article&articleid=2121&return=archive#:~:text=Nearly%203%20feet%20of%20snow,at%2015.8%20degrees%20below%20normal"]
    },
    {
        "title": "Mar-60",
        "eventType": "Winter Weather",
        "cardTitle": "Record Snow in Benham",
        "cardSubtitle": "46.5” in March, 108.2” for season",
        "decade": "1960",
        "cardDetailedText": "The monthly snowfall record was set in Benham, Kentucky, in Letcher County, where 46.5 inches of snow accumulated in March. Benham reported 108.2 inches over the entire 1959 to 1960 winter season. (Source: Kentucky Weather by Jerry Hill pg. 63).",
        "url": []
    },
    {
        "title": "28-Jun-60",
        "eventType": "High Precipitation",
        "cardTitle": "Rainfall Record in Muhlenberg County",
        "cardSubtitle": "10.40” in one day",
        "decade": "1960",
        "cardDetailedText": "A total 10.40 inches of rain was recorded in Muhlenberg County, setting a new record for Kentucky for most rainfall in a calendar day. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "1963",
        "eventType": "Drought",
        "cardTitle": "Second Driest Year",
        "cardSubtitle": "34.12” statewide average",
        "decade": "1960",
        "cardDetailedText": "Second driest year on record with a state average 34.12”, 68% of normal and 16.24” below normal.",
        "url": []
    },
    {
        "title": "Jan 23–24, 1963",
        "eventType": "Extreme Cold",
        "cardTitle": "Temperature Plunge Record",
        "cardSubtitle": "82°F drop in Bradfordville",
        "decade": "1960",
        "cardDetailedText": "A Kentucky record for plunging temperatures occurred across the state. Highs were around 50° F across the state on 1/23/1963 when an arctic mass moved in overnight and dropped temperatures well below 0° F. The largest drop was recorded in Bradfordville, where the temperature went from 52° F to -30° F – an 82° F plunge. This arctic front also set new records across the state for low temperatures. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Mar 11–13, 1963",
        "eventType": "Flood",
        "cardTitle": "Eastern Kentucky Flood",
        "cardSubtitle": "26 dead, 30,000 evacuated",
        "decade": "1960",
        "cardDetailedText": "Floods covered a wide area of eastern Kentucky, with 26 fatalities, 30,000 evacuated, and $98M in damages.",
        "url": [
            "https://pubs.usgs.gov/publication/wsp1830B"]
    },
    {
        "title": "Oct-63",
        "eventType": "Drought",
        "cardTitle": "Driest October on Record",
        "cardSubtitle": "0.14” statewide average",
        "decade": "1960",
        "cardDetailedText": "Driest October on record with an average 0.14” statewide, only 4% of normal (3.36” below normal).",
        "url": []
    },
    {
        "title": "Dec-65",
        "eventType": "Drought",
        "cardTitle": "Driest December on Record",
        "cardSubtitle": "0.66” statewide average",
        "decade": "1960",
        "cardDetailedText": "Driest December on record with an average 0.66” statewide, only 15% of normal (3.77” below normal).",
        "url": []
    },
    {
        "title": "Jun – Aug 1967",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest Summer on Record",
        "cardSubtitle": "Statewide average 71.2°F",
        "decade": "1960",
        "cardDetailedText": "Kentucky’s coldest summer with a state average 71.2°F, a cool 3.7°F below average.",
        "url": []
    },
    {
        "title": "Aug-67",
        "eventType": "Extreme Cold",
        "cardTitle": "Coolest August on Record (Tied)",
        "cardSubtitle": "Average temperature 70.0°F",
        "decade": "1960",
        "cardDetailedText": "Tied with August 1927 as Kentucky’s coolest August with a state average 70.0°F, 5.3°F below average.",
        "url": []
    },
    {
        "title": "23-Apr-68",
        "eventType": "Tornado",
        "cardTitle": "Northern Kentucky Tornado",
        "cardSubtitle": "F4 causes major damage",
        "decade": "1960",
        "cardDetailedText": "An F4 tornado hit northern Kentucky across Pendelton, Bracken, and Mason Counties. The tornado did extensive damage in Falmouth, Kentucky, and damaged 115 of the 127 homes in Dover, Kentucky. Five people were killed in Kentucky before the tornado moved into Ohio.",
        "url": []
    },
    {
        "title": "23-Jun-69",
        "eventType": "High Precipitation",
        "cardTitle": "Scottsville Rainfall Record",
        "cardSubtitle": "9.68” in 12 hours",
        "decade": "1960",
        "cardDetailedText": "Very heavy rainfall set a new record in Kentucky at the time for the amount of rainfall observed in 12 hours: 9.68 inches in Scottsville (Allen County). The amount of rainfall caused a local creek to flood, which consequently killed three people and damaged many homes. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "3-Apr-74",
        "eventType": "Tornado",
        "cardTitle": "Super Outbreak Tornadoes",
        "cardSubtitle": "15 tornadoes in KY, including state’s only F5",
        "decade": "1970",
        "cardDetailedText": "During “The Super Outbreak” 148 tornadoes were reported in 48 hours across 13 states, including Kentucky. The state’s only F5 tornado had wind speeds up to 225 miles per hour and destroyed downtown Brandenburg in Meade County, killing 31. An F4 tornado hit Louisville, killing 3 and injuring 200 more. A total of 15 tornadoes touched down across Kentucky, ranging from F1 to F5. (Sources: Kentucky Weather by Jerry Hill pg. 98; NWS)",
        "url": [
            "https://www.weather.gov/lmk/tornado_climatology_april31974",
            "https://www.army.mil/article/275125/former_soldier_meade_county_community_remember_devastation_of_1974_tornado#:~:text=The%20clouds%20also%20reminded%20many,way%20the%20nation%20tracks%20storms",
            "https://www.whas11.com/article/news/local/1974-super-tornado-outbreak-second-largest-us-history-kentucky-indiana-50-years-ago/417-0a265f8b-6a22-4ae3-ad61-f699ef2c3806#:~:text=The%20twisters%20took%20a%20tragic,injuring%20more%20than%20200%20others"]
    },
    {
        "title": "1976",
        "eventType": "Extreme Cold",
        "cardTitle": "Third Coldest Year",
        "cardSubtitle": "Statewide average 53.3°F",
        "decade": "1970",
        "cardDetailedText": "Kentucky’s 3rd coldest year with a state average of 53.3°F, 3.0°F below average.",
        "url": []
    },
    {
        "title": "Sep – Nov 1976",
        "eventType": "Extreme Cold",
        "cardTitle": "Coolest Fall on Record",
        "cardSubtitle": "Average temperature 50.8°F",
        "decade": "1970",
        "cardDetailedText": "Coolest fall on record with a state average 50.8°F, 6.7°F below average.",
        "url": []
    },
    {
        "title": "Nov-76",
        "eventType": "Extreme Cold, Drought",
        "cardTitle": "Driest and Coldest November",
        "cardSubtitle": "0.85” of rain and 37.5°F average",
        "decade": "1970",
        "cardDetailedText": "Driest November on record with a state average 0.85”, only 24% of normal (2.69” below normal). Also the coldest November on record with a state average 37.5°F, 8.7°F below average.",
        "url": []
    },
    {
        "title": "Dec 1976 – Feb 1977",
        "eventType": "Extreme Cold, Drought",
        "cardTitle": "Second Coldest and Driest Winter",
        "cardSubtitle": "Only 5.09” of rain, avg temp 27.8°F",
        "decade": "1970",
        "cardDetailedText": "Driest winter on record with a state average 5.09”, only 42% of normal (6.94” below normal). Kentucky’s second coldest winter with a state average 27.8°F, a full 9.1°F below average. A very brutal winter, similar to the characteristics of the winter of 1917 to 1918. The average temperature of the winter of 1976 to 1977 was 28.8° F. January 1977 set a new record at the time for the coldest month in Kentucky history with an average temperature of 18.4° F. The beginning of the 1970s had mild winters, but this was the first winter of three that had extreme winter conditions. (Source: Kentucky Weather by Jerry Hill)",
        "url": []
    },
    {
        "title": "Jan-77",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest January on Record",
        "cardSubtitle": "Average temperature 17.7°F",
        "decade": "1970",
        "cardDetailedText": "Kentucky’s coldest January on record with an average 17.7°F, an incredible 16.7°F below normal.",
        "url": []
    },
    {
        "title": "Dec 1977 – Feb 1978",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest Winter on Record",
        "cardSubtitle": "Average temperature 26.5°F",
        "decade": "1970",
        "cardDetailedText": "Kentucky’s coldest winter with a state average of 26.5°F, over 10.4°F below average. The beginning of the winter through January was colder than average, but new records were set when, in February, the average temperature was 13.5° F below normal. The widespread cold caused a very high demand for energy but which was in short supply. The fuel shortage was exacerbated by ice on the Ohio River which caused disruptions to the transportation of heating fuel oil, road salt, and coal. The cold also caused many power outages and broken water lines. (Source: Kentucky Weather by Jerry Hill)",
        "url": []
    },
    {
        "title": "1978",
        "eventType": "Extreme Cold",
        "cardTitle": "Fourth Coldest Year (Tied)",
        "cardSubtitle": "Average 53.4°F",
        "decade": "1970",
        "cardDetailedText": "Tied with 1979 as Kentucky’s 4th coldest year with a state average 53.4°F, 2.9°F below average.",
        "url": []
    },
    {
        "title": "20-Jan-78",
        "eventType": "Winter Weather",
        "cardTitle": "Record Snowfall in LaGrange",
        "cardSubtitle": "31 inches of snow",
        "decade": "1970",
        "cardDetailedText": "LaGrange in Oldham County reported 31 inches of snow, a record snowfall depth. (Source: Kentucky Weather by Jerry Hill).",
        "url": []
    },
    {
        "title": "Feb-78",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest February on Record",
        "cardSubtitle": "Average temperature 23.2°F",
        "decade": "1970",
        "cardDetailedText": "Kentucky’s coldest February on record with a state average of 23.2°F, 15.0°F below normal.",
        "url": []
    },
    {
        "title": "Dec 7–8, 1978",
        "eventType": "Flood",
        "cardTitle": "Central Kentucky Flooding",
        "cardSubtitle": "Record flooding in several towns",
        "decade": "1970",
        "cardDetailedText": "About 8” of rain fell across central Kentucky, flooding the Licking and Kentucky Rivers. Frankfort, Shepherdsville, Boston, and Munfordville saw record flooding. The state capital flooded and large evacuations were ordered in Paintsville.",
        "url": [
            "https://www.weather.gov/safety/flood-states-ky"]
    },
    {
        "title": "1979",
        "eventType": "Extreme Cold",
        "cardTitle": "Fourth Coldest Year (Tied)",
        "cardSubtitle": "Average 53.4°F",
        "decade": "1970",
        "cardDetailedText": "Tied with 1978 as Kentucky’s 4th coldest year with a state average 53.4°F, 2.9°F below average.",
        "url": []
    },
    {
        "title": "1979",
        "eventType": "Tropical Storm",
        "cardTitle": "Summer Tropical Storms",
        "cardSubtitle": "Three storms impacted KY",
        "decade": "1970",
        "cardDetailedText": "Kentucky was hit by three tropical storms in summer 1979: Hurricane Bob (mid-July), Hurricane David (late August/early September), and Hurricane Frederic (mid-September).",
        "url": []
    },
    {
        "title": "27-Jul-80",
        "eventType": "Earthquake",
        "cardTitle": "Sharpsburg Earthquake",
        "cardSubtitle": "Strongest quake in Kentucky history",
        "decade": "1980",
        "cardDetailedText": "A magnitude 5.2 earthquake hit Bath County. The Sharpsburg Earthquake was the strongest in Kentucky’s history and caused an estimated $3 million in damage in Maysville, Kentucky.",
        "url": [
            "https://kgs.uky.edu/kgsweb/olops/pub/kgs/SP17_12.pdf"]
    },
    {
        "title": "Jan-81",
        "eventType": "Drought",
        "cardTitle": "Driest January on Record",
        "cardSubtitle": "Only 0.87” of rain statewide",
        "decade": "1980",
        "cardDetailedText": "Driest January on record with a state average 0.87”, only 23% (-2.87”) of normal.",
        "url": []
    },
    {
        "title": "12-Feb-81",
        "eventType": "Pressure Record",
        "cardTitle": "Highest Pressure on Record",
        "cardSubtitle": "30.99 inHg in Louisville",
        "decade": "1980",
        "cardDetailedText": "Highest pressure recorded at an official weather station in Kentucky. The observed pressure in Louisville was 30.99 inches of mercury (1,049.4 millibars). (Pressures corrected to sea level).",
        "url": []
    },
    {
        "title": "May-83",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest May on Record",
        "cardSubtitle": "9.92” statewide average",
        "decade": "1980",
        "cardDetailedText": "Wettest May on record with a state average 9.92”, 4.83” above normal (195% of normal).",
        "url": []
    },
    {
        "title": "Apr, 1987",
        "eventType": "Winter Weather",
        "cardTitle": "Spring Snowstorm and Flooding",
        "cardSubtitle": "28” of snow and flash floods",
        "decade": "1980",
        "cardDetailedText": "From April 3 to April 5, 1987, up to 28 inches of snow fell across Kentucky. High winds created snow drifts up to 10 feet tall, as reported in Letcher County. Rapid warming caused the snow to melt very quickly, which resulted in flash flooding in Letcher County and Pike County. (Source: Kentucky Weather by Jerry Hill pg. 63)",
        "url": []
    },
    {
        "title": "1988",
        "eventType": "Drought",
        "cardTitle": "1988 Extreme Drought",
        "cardSubtitle": "PDSI dropped to -3 to -4",
        "decade": "1980",
        "cardDetailedText": "The 6th driest March – August on record (9.00” below normal, 68% of normal), the Palmer Drought Severity Index (PDSI) dropped to -3 to -4, indicating an extreme drought across Kentucky. Upper-air circulation blocking patterns created dry conditions beginning in the spring of 1988. Waves of high pressure and a lack of low-pressure systems from the Gulf of Mexico created such dry conditions that rivers, even the Mississippi River, dried up, and residents had water use restrictions. Agriculture took significant losses, and prices of products rose. (Source: Kentucky Weather by Jerry Hill pg. 107)",
        "url": []
    },
    {
        "title": "Oct-88",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest October on Record",
        "cardSubtitle": "Statewide average 50.0°F",
        "decade": "1980",
        "cardDetailedText": "Kentucky’s coldest October on record with a state average 50.0°F, 7.6°F below average.",
        "url": []
    },
    {
        "title": "Feb-89",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest February on Record",
        "cardSubtitle": "9.85” of rain statewide",
        "decade": "1980",
        "cardDetailedText": "The wettest February for the state on record with 9.85” for the month, over 255% (5.99”) above normal.",
        "url": []
    },
    {
        "title": "Dec-89",
        "eventType": "Extreme Cold",
        "cardTitle": "Coldest December on Record",
        "cardSubtitle": "Average temperature 24.9°F",
        "decade": "1980",
        "cardDetailedText": "The coldest December on record with a state average 24.9°F, a chilling 13.2°F below average.",
        "url": []
    },
    {
        "title": "Dec-90",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest December on Record",
        "cardSubtitle": "10.67” statewide average",
        "decade": "1990",
        "cardDetailedText": "Wettest December on record with a state average 10.67”, 241% of normal (4.43” above normal).",
        "url": []
    },
    {
        "title": "14-Mar-93",
        "eventType": "Winter Weather",
        "cardTitle": "Storm of the Century Blizzard",
        "cardSubtitle": "Up to 30” of snow and 5 deaths",
        "decade": "1990",
        "cardDetailedText": "As part of 1993’s “Storm of the Century”, a blizzard covered eastern and southeastern Kentucky with up to 30 inches of snow. The blizzard shut down Interstate 75, and high winds created 8-to-10-foot snow drifts. Five deaths in Kentucky were attributed to the blizzard. ",
        "url": []
    },
    {
        "title": "Jan-94",
        "eventType": "Extreme Cold",
        "cardTitle": "Severe Cold and Snowstorm",
        "cardSubtitle": "New state cold record: -37°F",
        "decade": "1990",
        "cardDetailedText": "One of the most severe extreme cold events in Kentucky’s weather history. A blizzard coated the ground with about an inch of ice, followed by 6 inches up to a maximum of 26 inches in Mason County. The snowstorm caused all state, interstate, and federal highways to close for a couple of days. An arctic front followed the blizzard and brought record cold temperatures, measuring as low as -37° F in Shelbyville – a new Kentucky cold weather record at the time.",
        "url": []
    },
    {
        "title": "1-Mar-97",
        "eventType": "Flood",
        "cardTitle": "Louisville Flash Flood",
        "cardSubtitle": "10.48” in 24 hours; 21 deaths statewide",
        "decade": "1990",
        "cardDetailedText": "The second highest state rainfall observed during any 24-hour period was recorded in Louisville at 10.48” between February 28 and March 1, 1977. The flooding from the rain caused 21 deaths across Kentucky. Over 100 counties were declared federal disaster areas. The rains caused over $200M in damages in Louisville and $400M in damages regionwide.",
        "url": [
            "https://www.weather.gov/safety/flood-states-ky"]
    },
    {
        "title": "Mar-97",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest March on Record",
        "cardSubtitle": "11.11” statewide average",
        "decade": "1990",
        "cardDetailedText": "The wettest March on record for Kentucky with a state average of 11.11”, 6.43” (237%) above normal.",
        "url": []
    },
    {
        "title": "Feb 3–6, 1998",
        "eventType": "Winter Weather",
        "cardTitle": "Record Snowstorm in Louisville",
        "cardSubtitle": "22.4” snowfall record",
        "decade": "1990",
        "cardDetailedText": "A slow-moving storm system dropped up to 25 inches of snow across northern Kentucky. Louisville broke its record for most snowfall from a single storm at 22.4 inches.",
        "url": [
            "https://www.weather.gov/lmk/top10winter"]
    },
    {
        "title": "16-Apr-98",
        "eventType": "Severe Storm",
        "cardTitle": "Severe Supercell Storm",
        "cardSubtitle": "2 deaths, $500M in damages",
        "decade": "1990",
        "cardDetailedText": "A supercell thunderstorm moved across south-central Kentucky with significant hail, tornadoes, and high winds. There were two fatalities in Glasgow, and more than $500 million in damages. (Source: Kentucky Weather by Jerry Hill pg. 87)",
        "url": []
    },
    {
        "title": "1999",
        "eventType": "Drought",
        "cardTitle": "1999 Drought Emergency",
        "cardSubtitle": "Driest Jul–Sep period in history",
        "decade": "1990",
        "cardDetailedText": "Consistent high-pressure systems across the Midwest led to a severe drought in Kentucky during mid- to late summer 1999. Only 2.01 inches of rain were recorded in Louisville from July to September 1999, and which coincided with the driest such period in state history with a state average of only 5.43”, only 45% of normal and 6.64” below normal. A state of emergency was declared. Ninety-six counties were under a water shortage warning, with the remainder on a water shortage watch. Many people across the state had to practice mandatory water conservation. (Source: Kentucky Weather by Jerry Hill pg. 109)",
        "url": []
    },
    {
        "title": "6-Jun-03",
        "eventType": "Earthquake",
        "cardTitle": "Western Kentucky Earthquake",
        "cardSubtitle": "Magnitude 4.0 in Carlisle County",
        "decade": "2000",
        "cardDetailedText": "A magnitude 4.0 earthquake struck in western Kentucky around Carlisle County.",
        "url": [
            "https://kgs.uky.edu/kgsweb/olops/pub/kgs/SP17_12.pdf"]
    },
    {
        "title": "7-Apr",
        "eventType": "Extreme Cold",
        "cardTitle": "April Freeze After Early Spring",
        "cardSubtitle": "$130M in agricultural losses",
        "decade": "2000",
        "cardDetailedText": "An early spring brought warmer temperatures across Kentucky in March, but an arctic front moved into the area at the beginning of April. Crops had begun growing due to the warm temperatures, but the cold front caused about $130 million in early season agricultural losses.",
        "url": []
    },
    {
        "title": "7-Aug",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest August on Record",
        "cardSubtitle": "Statewide average 80.9°F",
        "decade": "2000",
        "cardDetailedText": "Kentucky’s warmest August on record with a state average 80.9°F, a sizzling 5.6°F above average.",
        "url": []
    },
    {
        "title": "7-Aug",
        "eventType": "Drought",
        "cardTitle": "2007 Drought Emergency",
        "cardSubtitle": "Extreme drought and federal disaster declared",
        "decade": "2000",
        "cardDetailedText": "A federal disaster was declared in Kentucky for harsh drought conditions. The United States Drought Monitor rated Kentucky in extreme drought conditions for much of August. The agriculture industry had major losses as the dry conditions continued into the fall months.",
        "url": [
            "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"]
    },
    {
        "title": "14-Sep-08",
        "eventType": "Severe Storm",
        "cardTitle": "Hurricane Ike Remnants",
        "cardSubtitle": "Widespread wind damage and blackouts",
        "decade": "2000",
        "cardDetailedText": "The remnants of Hurricane Ike brought high winds and storms to Kentucky. Louisville, Kentucky, experienced the largest blackout in 30 years, shutting down the Louisville International Airport. A state of emergency was declared, and falling limbs caused four fatalities.",
        "url": [
            "https://www.weather.gov/lmk/sep_14_08"]
    },
    {
        "title": "Jan 26–28, 2009",
        "eventType": "Winter Weather",
        "cardTitle": "2009 Ice and Snowstorm",
        "cardSubtitle": "Record-breaking power outage",
        "decade": "2000",
        "cardDetailedText": "An ice and snowstorm caused 609,000 homes and businesses to lose power, setting the record for the largest power outage in Kentucky history.",
        "url": [
            "https://www.weather.gov/lmk/jan_2009_ice_and_snow"]
    },
    {
        "title": "May 1–2, 2010",
        "eventType": "Flood",
        "cardTitle": "Central KY Flooding",
        "cardSubtitle": "10.14” rain in 2 days; 5 deaths",
        "decade": "2010",
        "cardDetailedText": "Heavy rain across central Kentucky caused area rivers and streams to flood. Multiple cities, including Bowling Green, set a record at that time for the most amount of rainfall in a two-day period at 10.14 inches. The torrential rain caused about $30M in damage and took the lives of five Kentuckians.",
        "url": [
            "https://www.weather.gov/lmk/flood_050210_how_it_happened",
            "https://www.weather.gov/lmk/flood_050210_how_it_happened"]
    },
    {
        "title": "2011",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Year on Record",
        "cardSubtitle": "64.35” statewide average",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s wettest year on record with a state average 64.35”, 128% of normal (13.99” above normal).",
        "url": []
    },
    {
        "title": "Mar – May 2011",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Spring on Record",
        "cardSubtitle": "24.33” statewide average",
        "decade": "2010",
        "cardDetailedText": "Wettest spring in state history with an average 24.33”, a full 9.83” above normal (168% of normal).",
        "url": []
    },
    {
        "title": "11-Apr",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest April on Record",
        "cardSubtitle": "12.07” statewide average",
        "decade": "2010",
        "cardDetailedText": "Wettest April on record with 12.07”, 7.34” (255%) above normal.",
        "url": []
    },
    {
        "title": "12-Mar",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest March on Record",
        "cardSubtitle": "Average 58.0°F",
        "decade": "2010",
        "cardDetailedText": "Warmest March on record with a state average temperature of 58.0°F, 11.6°F above normal.",
        "url": []
    },
    {
        "title": "Mar – May 2012",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest Spring on Record",
        "cardSubtitle": "Average 61.6°F",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s warmest spring on record with a statewide average temperature of 61.6°F, 5.6°F above average.",
        "url": []
    },
    {
        "title": "2012",
        "eventType": "Extreme Heat",
        "cardTitle": "Third Warmest Year",
        "cardSubtitle": "Statewide average 58.4°F",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s 3rd warmest year on record with a state average of 58.4°F, 2.1°F above average.",
        "url": []
    },
    {
        "title": "Jan – Aug 2012",
        "eventType": "Extreme Heat",
        "cardTitle": "Heat Waves and Drought",
        "cardSubtitle": "Multiple days over 100°F",
        "decade": "2010",
        "cardDetailedText": "From January to August 2012, Kentucky set many heat records across Kentucky. Many days over 100°F were recorded across the state, and some regions of Kentucky experienced drought conditions during the summer months.",
        "url": [
            "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"]
    },
    {
        "title": "2-Mar-12",
        "eventType": "Tornado",
        "cardTitle": "Tornado Outbreak",
        "cardSubtitle": "19 tornadoes; 20+ dead",
        "decade": "2010",
        "cardDetailedText": "Among the largest tornado outbreaks to hit Kentucky. There were 19 tornadoes observed across at least 27 counties. An EF-3 tornado hit Magoffin County and stayed on the ground for 49 miles. There was a total of more than 20 deaths and 200 injuries across Kentucky, and more than $150 million in damage.",
        "url": [
            "https://www.wkyt.com/content/news/Top-weather-events-in-Central-Kentucky-over-the-decade-566572991.html"]
    },
    {
        "title": "10-Nov-12",
        "eventType": "Earthquake",
        "cardTitle": "Southeastern KY Earthquake",
        "cardSubtitle": "Magnitude 4.2 in Perry and Letcher Counties",
        "decade": "2010",
        "cardDetailedText": "A magnitude 4.2 earthquake struck southeastern Kentucky, affecting Perry and Letcher Counties.",
        "url": [
            "https://kgs.uky.edu/kgsweb/olops/pub/kgs/SP17_12.pdf"]
    },
    {
        "title": "Feb 15–16, 2015",
        "eventType": "Winter Weather",
        "cardTitle": "Lexington Snowstorm",
        "cardSubtitle": "10.2” snow; daily record",
        "decade": "2010",
        "cardDetailedText": "A snowstorm set records in Lexington and central Kentucky. Lexington received 10.2 inches of snow, setting a new daily snowfall record. Much of central Kentucky received a foot or more of snow.",
        "url": [
            "https://www.lex18.com/anniversary-of-february-15-16-2015-snow"]
    },
    {
        "title": "4-Mar-15",
        "eventType": "Winter Weather",
        "cardTitle": "Louisville Snowstorm",
        "cardSubtitle": "11.9” in Louisville; 25” south of city",
        "decade": "2010",
        "cardDetailedText": "A second snowstorm came over Kentucky only two weeks after the February 15th and 16th snowstorm. The Louisville airport weather station measured 11.9 inches of snow, making this storm the fourth largest in Louisville’s history, but areas south of Louisville received up to 25 inches of snow. Interstate 65 was closed down after more than 200 semi-trucks became stuck. The National Guard came to bring supplies and rescue drivers. The snowstorm was followed by extremely cold temperatures as low as -8°F in Hardin County.",
        "url": [
            "https://www.wlky.com/article/on-this-day-5-years-ago-nearly-200-semis-stranded-after-i-65-hammered-with-snow/31228587"]
    },
    {
        "title": "15-Jul",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest July on Record",
        "cardSubtitle": "9.37” statewide average",
        "decade": "2010",
        "cardDetailedText": "Wettest July on record with a state average 9.37”, 193% of normal (4.51” above normal).",
        "url": []
    },
    {
        "title": "Jul 13–14, 2015",
        "eventType": "Flood",
        "cardTitle": "Eastern KY Flash Floods",
        "cardSubtitle": "2 dead; 200 homes damaged",
        "decade": "2010",
        "cardDetailedText": "Flash flooding in eastern Kentucky, specifically Johnson and Rowan Counties, causes the governor to declare a state of emergency. The rainfall rate was around 6-7” per hour, according to radar estimates. The flash flooding took at least two lives and damaged around 200 homes across Johnson and Rowan Counties.",
        "url": [
            "https://floodlist.com/america/usa/kentucky-floods-2-dead-several-missing-july-2015",
            "https://www.wkyt.com/content/news/Top-weather-events-in-Central-Kentucky-over-the-decade-566572991.html"]
    },
    {
        "title": "15-Dec",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest December on Record",
        "cardSubtitle": "Average temperature 48.7°F",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s warmest December on record with a state average of 48.7°F, 10.6°F above normal.",
        "url": []
    },
    {
        "title": "17-Feb",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest February on Record",
        "cardSubtitle": "Average temperature 46.2°F",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s warmest February on record with a state average of 46.2°F, 8°F above normal.",
        "url": []
    },
    {
        "title": "18-May",
        "eventType": "Extreme Heat",
        "cardTitle": "Warmest May on Record",
        "cardSubtitle": "Average temperature 71.8°F",
        "decade": "2010",
        "cardDetailedText": "Kentucky’s warmest May on record with a state average of 71.8°F, 6.6°F above average.",
        "url": []
    },
    {
        "title": "Sep – Nov 2018",
        "eventType": "High Precipitation",
        "cardTitle": "Wettest Fall (Tied)",
        "cardSubtitle": "16.95” total rainfall",
        "decade": "2010",
        "cardDetailedText": "Tied with 1919 as the wettest fall on record with 16.95” of rain, 159% of normal (6.32” above normal).",
        "url": []
    },
    {
        "title": "19-Sep",
        "eventType": "Drought",
        "cardTitle": "Driest September on Record",
        "cardSubtitle": "Only 0.22” rainfall",
        "decade": "2010",
        "cardDetailedText": "Driest September on record with only 0.22” of rain, 3.37” below normal (just 6% of normal).",
        "url": []
    },
    {
        "title": "Sep – Oct 2019",
        "eventType": "Drought",
        "cardTitle": "Flash Drought in Kentucky",
        "cardSubtitle": "Lexington recorded 0” in September",
        "decade": "2010",
        "cardDetailedText": "A flash drought hit Kentucky. Lexington had 0” precipitation in September 2019, the first calendar month in its history to record no rain. Louisville also experienced a very dry month of September, with only 0.04” of precipitation.",
        "url": [
            "https://www.weather.gov/lmk/top10heat#:~:text=The%20drought%20in%201954%20was,or%20extreme%20drought%20through%20November"]
    },
    {
        "title": "Feb 10–16, 2021",
        "eventType": "Winter Weather",
        "cardTitle": "Eastern KY Ice Storms",
        "cardSubtitle": "4 deaths, 150,000+ without power",
        "decade": "2020",
        "cardDetailedText": "Two ice storms struck eastern Kentucky, prompting a State of Emergency. The storms caused 4 fatalities, widespread power outages, and damage from fallen trees, frozen water systems, landslides, and mudslides.",
        "url": [
            "https://www.kentucky.gov/Pages/Activity-stream.aspx?n=GovernorBeshear&prId=669"]
    },
    {
        "title": "Dec 10–11, 2021",
        "eventType": "Tornado",
        "cardTitle": "Historic Tornado Outbreak",
        "cardSubtitle": "80 fatalities; record 120.1 mph gust",
        "decade": "2020",
        "cardDetailedText": "One of Kentucky’s most severe tornadic outbreaks, responsible for 4 out of the top 5 deadliest tornadoes in the state’s history. One tornado was an EF-4 that began in Tennessee and tracked 165.7 miles across Kentucky. The city of Mayfield in Graves County was left in ruins. An EF-3 tornado touched down in Warren County and tracked through Bowling Green, narrowly missing Western Kentucky University’s campus. The estimated peak winds of this EF-3 were 165 mph, and the tornado track was just under 30 miles. Multiple smaller tornadoes touched down across Kentucky with a total death toll of 80 people. A wind gust associated with the EF-4 tornado set a new state record of 120.1 mph observed at the Mesonet station in Caldwell County.",
        "url": [
            "https://www.weather.gov/pah/December-10th-11th-2021-Tornado",
            "https://www.weather.gov/lmk/December112021Tornadoes",
            "https://www.whas11.com/article/weather/kentucky-tornadoes/western-kentucky-tornadoes-victims-december-2021-mayfield-dawson-springs-bowling-green/417-0c2b98e6-2b22-4d3a-8f9a-82b313a59454",
            "https://www.ncei.noaa.gov/monitoring-content/extremes/scec/reports/20220328-Kentucky-Strongest-Wind-Gust.pdf"
        ]
    },
    {
        "title": "Jul 26–30, 2022",
        "eventType": "Flood",
        "cardTitle": "Eastern Kentucky Flooding",
        "cardSubtitle": "43 deaths; 14–16” rainfall",
        "decade": "2020",
        "cardDetailedText": "A series of training storms over a five-day period led to 14” to 16” of rainfall across eastern Kentucky. The storms measured rainfall rates of over 4” per hour, and coupled with the mountainous terrain of Eastern Kentucky, led to deadly flash flooding. Some areas received up to 8” within 24 hours. The flooding caused 43 deaths, and wiped away many homes, highways, and infrastructure for a number of communities. ",
        "url": [
            "https://www.weather.gov/jkl/July2022Flooding"]
    },
    {
        "title": "3-Mar-23",
        "eventType": "Severe Storm",
        "cardTitle": "Widespread Windstorm",
        "cardSubtitle": "4 deaths; 80 mph winds",
        "decade": "2020",
        "cardDetailedText": "Straight-line winds associated with a high-pressure system blew across nearly all of Kentucky with up to 80 mph winds. The storm killed four people, and more than half a million people lost power due to downed power lines. The President declared a major emergency in the region, as the windstorm was Kentucky's fourth billion-dollar disaster since the February 2021 ice storm. Several new low-pressure records were set across the state.",
        "url": [
            "https://www.wkyt.com/2023/05/09/march-3rd-storms-declared-kentuckys-fourth-billion-dollar-weather-event/"]
    },
    {
        "title": "19-Jul-23",
        "eventType": "Flood",
        "cardTitle": "Western KY Flood and Rain Record",
        "cardSubtitle": "New 24-hr rainfall record: 11.28”",
        "decade": "2020",
        "cardDetailedText": "Far western Kentucky saw 6-12 inches of precipitation, which caused large amounts of flooding. No fatalities were recorded from the storms, but major infrastructure damage was incurred with many homes, businesses, and roads flooded. A new state 24-hour rainfall record was set at the Mayfield Kentucky Mesonet station with 11.28” of rainfall. ",
        "url": [
            "https://www.weather.gov/pah/FloodingJuly19_2023"]
    },
    {
        "title": "2024",
        "eventType": "Extreme Heat",
        "cardTitle": "Hottest Year on Record",
        "cardSubtitle": "State average 58.8°F",
        "decade": "2020",
        "cardDetailedText": "The hottest year on record with a state average 58.8°F, 2.5°F above average. 2024 was in the top five hottest years for 119 out of 120 Kentucky Counties. More than half of the 120 counties experienced their hottest year ever. The high average temperatures are attributed to a warm winter and warmer overnight temperatures throughout 2024. ",
        "url": [
            "https://www.lpm.org/news/2025-02-17/for-all-but-one-kentucky-county-2024-was-one-of-the-five-hottest-years-on-record"]
    },
    {
        "title": "27-Sep-24",
        "eventType": "Tropical Storm",
        "cardTitle": "Remnants of Hurricane Helene",
        "cardSubtitle": "15% of homes lost power",
        "decade": "2020",
        "cardDetailedText": "Hurricane Helene made landfall in Florida as a Category 4 and tracked north to Kentucky the following day. The remnants caused power outages in about 15% of Kentucky households, especially in Eastern Kentucky. Many counties and cities in Eastern Kentucky declared a state of emergency. Wind gusts reached over 60 miles per hour, and over five inches of rain fell. Kentucky was in a slight drought, but Hurricane Helene brought precipitation which alleviated the dry conditions.",
        "url": [
            "https://www.lpm.org/news/2024-09-27/helene-hammering-kentucky-with-wind-and-rain",
            "https://www.weather.gov/jkl/2024-09-27-easternkentucky-helene-damaging-winds#:~:text=The%20remnants%20of%20Hurricane%20Helene,fast%2Dmoving%20Category%204%20hurricane"]
    },
    {
        "title": "24-Oct",
        "eventType": "Drought",
        "cardTitle": "Second Driest October",
        "cardSubtitle": "Only 0.20” statewide average",
        "decade": "2020",
        "cardDetailedText": "October 2024 was the second driest in state history, averaging just 0.20” of rainfall—only 6% of normal.",
        "url": []
    },
    {
        "title": "Feb 14–16, 2025",
        "eventType": "Flood",
        "cardTitle": "Statewide Flooding",
        "cardSubtitle": "10 deaths; 1,000 rescues",
        "decade": "2020",
        "cardDetailedText": "A major statewide flood occurred across much of Kentucky with 48-hour precipitation totals of 2 to 6+ inches recorded across the entire state. Twelve river gauge sites recorded top five crests with the event. Across the Commonwealth the rains were responsible for ten fatalities, over 1,000 water rescues, and 40,000+ customers without power. Disaster declarations were issued for 18 counties. The National Weather Service issued 30 flood warnings, 47 flash flood warnings, 11 severe thunderstorm warnings, and two tornado warnings.",
        "url": [
            "https://www.weather.gov/lmk/KYFlooding#:~:text=A%20prolonged%20period%20of%20heavy,central%20portions%20of%20the%20state",
            "https://www.kktv.com/2025/02/16/flooding-us-southeast-leaves-least-4-dead-snow-ice-wind-cause-winter-misery-elsewhere/",
        ]
    },
    {
        "title": "Mar 30 – Apr 6, 2025",
        "eventType": "Flood, Tornado",
        "cardTitle": "Second 2025 Flood + Tornadoes",
        "cardSubtitle": "EF-3 hits Louisville",
        "decade": "2020",
        "cardDetailedText": "The second major statewide flood event of 2025 occurred with 5-day rainfall totals of 5 to 15+ inches over all but southeastern Kentucky. Marshall County measured 15.86 inches over the five-day period, and areas in Central Kentucky averaged 10 to 13 inches of precipitation. At least five river gauge sites along the Kentucky and Green rivers recorded top three crests. The floods were responsible for seven fatalities, major infrastructure damage, and over 500 road closures including several major interstates. Disaster declarations were issued for 13 counties. Six tornadoes touched down across the state, ranging from EF-1 to an EF-3 in Louisville.",
        "url": [
            "https://www.weather.gov/lmk/2025-04-02-Severe_Event",
            "https://www.kentucky.com/news/weather-news/article303676851.html"]
    }
];